<template>
    <el-row class="box">
        <el-row type="flex" class="row-bg-top header" justify="center">
            <el-col :span="17" class='content'>
                <el-row class=" head_top" > 
                    <el-col :span="12" class='head_top_left'>  
                         <a href="http://www.jssyyjxh.com" class="head-title">江苏省音乐家协会欢迎您</a>         
                    </el-col>    
                    <el-col :span="12" class='top_login'>  
                        <a class='cor'>您好，{{user}}</a> 
                        | <a class='cor' @click='quit()'>注销</a>     
                    </el-col>
                </el-row>    
            </el-col>
        </el-row>
    </el-row>    
</template>
<script>
export default {
  data() {
    return {
        user:null
    };
  },
  created() {
    this.user = sessionStorage.getItem('username')
    console.log(sessionStorage.getItem('username'))
  },
  methods: {
      //注销
    quit(){
        sessionStorage.removeItem('username')
        window.Global.removeLocalStorage('token')
        window.Global.removeLocalStorage('username')
        window.Global.removeLocalStorage('password')
        this.$router.push({name:"message"})
    }
  }
};
</script>
<style lang="less">
@import "../../static/less/bg.less";
</style>


   


// WEBPACK FOOTER //
// src/components/navTop.vue